<!-- Mod Toolbar -->
<div class="mod-toolbar">
  @for (kat of kategoriler; track kat.value) {
  <button class="mod-btn"
          [class.active]="kategori === kat.value"
          [style.--active-color]="kat.renk"
          (click)="secKategori(kat.value)"
          [title]="kat.label">
    <span class="mod-icon">{{kat.ikon}}</span>
  </button>
  }
</div>

<div class="divider"></div>

<!-- Seçim Durumu -->
<div class="status-row">
  <span class="status-label">Konum:</span>
  <span class="status-value" [class.selected]="noktaPozisyonu">
    {{noktaPozisyonu ? 'Seçildi ✓' : 'Seçilmedi'}}
  </span>
  <button class="pick-btn" (click)="pozisyonSec()" [disabled]="secimModu">
    <i class="icon crosshairs"></i>
  </button>
</div>

<!-- Başlık Input -->
<div class="input-row">
  <input type="text" [(ngModel)]="baslik" placeholder="Başlık..."
         class="title-input" (ngModelChange)="onizlemeGuncelle()">
</div>

<!-- Açıklama Input -->
<div class="input-row">
  <textarea [(ngModel)]="aciklama" placeholder="Açıklama..."
            class="desc-input" rows="2" (ngModelChange)="onizlemeGuncelle()"></textarea>
</div>

<div class="divider"></div>

<!-- Ayarlar -->
<div class="options-row">
  <label class="opt" title="Zoom bağımsız boyut">
    <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="onizlemeGuncelle()">
    <span>Sabit</span>
  </label>
  <label class="opt" title="Animasyonlu pulse efekti">
    <input type="checkbox" [(ngModel)]="pulseAktif" (ngModelChange)="onizlemeGuncelle()">
    <span>Pulse</span>
  </label>
  <label class="opt" title="Etiket her zaman görünsün">
    <input type="checkbox" [(ngModel)]="etiketGorunsun" (ngModelChange)="onizlemeGuncelle()">
    <span>Etiket</span>
  </label>
</div>

<div class="divider"></div>

<!-- Sonuç Bilgisi -->
@if (noktaPozisyonu) {
<div class="result-box">
  <div class="result-row">
    <span class="result-icon">{{secilenKategori?.ikon}}</span>
    <span class="result-title">{{baslik || 'Nokta'}}</span>
  </div>
  <div class="result-coords">
    X: {{noktaPozisyonu.x.toFixed(2)}} &nbsp;
    Y: {{noktaPozisyonu.y.toFixed(2)}} &nbsp;
    Z: {{noktaPozisyonu.z.toFixed(2)}}
  </div>
</div>
}

<div class="divider"></div>

<!-- Alt Butonlar -->
<div class="footer-row">
  <button class="btn-add" (click)="ekle()" [disabled]="!eklemeAktif">
    Ekle
  </button>
  <button class="btn-close" (click)="kapat()">
    Kapat
  </button>
</div>
